module.exports = __webpack_public_path__ + "static/blog33-5a4c179ac8d4d967dc958630906b1aa1.png";